// extracted by mini-css-extract-plugin
module.exports = {"button":"_2a549-","hasIcon":"ViRCh-","buttonText":"fmjOM-","primary":"_1gH9y-","secondary":"_22F7i-","tertiary":"_3wy6b-","danger":"_3paZf-","icon":"_2clqH-"};